.wrapper {
  min-height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  color: var(--text-dark);
  background-color: var(--gray-lightest);
}

.container {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1200px;
  align-items: flex-start;
  position: relative;
  top: -14rem;
  padding: 0 1.5rem;
  margin-bottom: -10rem;
}

.titleWrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  background-color: var(--white);
  background-image: url("bg-title.png");
  background-size: cover;
  border-radius: 8px 8px 0 0;
  padding-left: 2rem;
}

.title {
  color: var(--text-dark);
  font-family: 'Syne';
  font-size: 2rem;
  font-weight: 500;
}

.subtitle {
  color: var(--gray-dark);
  font-family: 'Aeroport';
  font-size: 1rem;
}

.contentWrapper {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 0;
}
